import { isObject, isString, isArray } from 'utils/typeUtils';
import { isNumber } from '../utils/typeUtils';

/**
 * メニューの種別
 */
export const MENU_TYPES = {
  GENERAL: 'general',
  SPECIAL: 'special',
} as const;

/**
 * メニュー種別の型
 */
export type MenuType = typeof MENU_TYPES[keyof typeof MENU_TYPES];

/**
 * メニュー from api
 */
export type OriginalMenu = {
  id: number;
  name: string;
  type: MenuType;
  categoryId: number;
  description: string;
  displayOrder: number;
};

/**
 * メニュー種別 from api の型ガード
 */
const isMenuType = (arg: unknown): arg is MenuType => {
  const a = arg as MenuType;
  const menuTypes = Object.values(MENU_TYPES);

  return menuTypes.includes(a);
};

/**
 * メニュー from api の型ガード
 */
export const isOriginalMenu = (arg: unknown): arg is OriginalMenu => {
  const a = arg as OriginalMenu;

  return (
    isObject(a) &&
    isNumber(a.id) &&
    isString(a.name) &&
    isMenuType(a.type) &&
    isNumber(a.categoryId) &&
    isString(a.description) &&
    isNumber(a.displayOrder)
  );
};

/**
 * メニュー from api の配列の型ガード
 */
export const isOriginalMenus = (arg: unknown): arg is OriginalMenu[] => {
  const a = arg as OriginalMenu[];

  return isObject(a) && isArray<OriginalMenu>(a, isOriginalMenu);
};
